import React from "react"
import Navbar from "../../../Common/Navbar"
import Footer from "../../../Common/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import AddBatchComp from "./Component/AddBatchComp"


const AddBatch =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <AddBatchComp />
        </div>
        <Footer />
        </>
    )
}

export default AddBatch